<template>
    <a-layout-header class="header">
        <div class="header-content">
            <div class="logo">
                <router-link to="/">
                    <img src="@/assets/logo-all.png" alt="Company Logo" />
                    <!-- <span>医药科技</span> -->
                </router-link>
            </div>
            <!-- 移动端菜单按钮 -->
            <a-button class="menu-mobile-button" @click="showDrawer">
                <MenuOutlined />
            </a-button>
            <!-- PC端菜单 -->
            <a-menu mode="horizontal" v-model:selectedKeys="selectedKeys" class="menu">
                <a-menu-item key="home">
                    <router-link to="/">首頁</router-link>
                </a-menu-item>
                <a-menu-item key="products">
                    <router-link to="/products">產品中心</router-link>
                </a-menu-item>
                <a-menu-item key="news">
                    <router-link to="/news">新聞中心</router-link>
                </a-menu-item>
                <a-menu-item key="about">
                    <router-link to="/about">關於我們</router-link>
                </a-menu-item>
                <a-menu-item key="contact">
                    <router-link to="/contact">聯繫我們</router-link>
                </a-menu-item>
            </a-menu>
        </div>
        <!-- 移动端抽屉菜单 -->
        <a-drawer placement="right" :visible="visible" @close="onClose" :closable="false" width="250">
            <a-menu mode="inline" v-model:selectedKeys="selectedKeys" class="drawer-menu">
                <a-menu-item key="home">
                    <router-link to="/" @click="onClose">首頁</router-link>
                </a-menu-item>
                <a-menu-item key="products">
                    <router-link to="/products" @click="onClose">產品中心</router-link>
                </a-menu-item>
                <a-menu-item key="news">
                    <router-link to="/news" @click="onClose">新聞中心</router-link>
                </a-menu-item>
                <!-- <a-menu-item key="resources">
                    <router-link to="/resources" @click="onClose">{{ $t('menu.resources') }}</router-link>
                </a-menu-item> -->
                <a-menu-item key="about">
                    <router-link to="/about" @click="onClose">關於我們</router-link>
                </a-menu-item>
                <a-menu-item key="contact">
                    <router-link to="/contact" @click="onClose">聯繫我們</router-link>
                </a-menu-item>
            </a-menu>
        </a-drawer>
    </a-layout-header>
</template>

<script>
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { MenuOutlined } from '@ant-design/icons-vue'
import { useI18n } from 'vue-i18n'

export default {
    name: 'LayoutHeader',
    components: {
        MenuOutlined,
    },
    setup() {
        const route = useRoute()
        const { locale } = useI18n()
        const selectedKeys = ref([route.name?.toLowerCase() || 'home'])
        const visible = ref(false)
        const currentLanguage = computed(() => locale.value)

        const languages = [
            { code: 'en', label: 'English' },
            { code: 'zh', label: '中文繁體' },
            { code: 'ja', label: '日本語' }
        ]

        const currentLanguageLabel = computed(() => {
            return languages.find(lang => lang.code === currentLanguage.value)?.label
        })

        const handleLanguageChange = ({ key }) => {
            locale.value = key
            localStorage.setItem('language', key)
        }

        const showDrawer = () => {
            visible.value = true
        }

        const onClose = () => {
            visible.value = false
        }

        return {
            selectedKeys,
            visible,
            showDrawer,
            onClose,
            currentLanguage,
            currentLanguageLabel,
            languages,
            handleLanguageChange
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    padding: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1000;

    &-content {
        @include flex-between;
        max-width: 1200px;
        margin: 0 auto;
        height: 64px;
        padding: 0 $spacing-md;

        @media (max-width: 768px) {
            padding: 0 $spacing-sm;
        }
    }

    .logo {
        a {
            @include flex-center;
            text-decoration: none;
            color: $text-color;
            font-size: 20px;
            font-weight: bold;

            img {
                height: 32px;
                margin-right: $spacing-sm;
            }

            span {
                @media (max-width: 768px) {
                    font-size: 16px;
                }
            }
        }
    }

    .menu-mobile-button {
        display: none;

        @media (max-width: 768px) {
            display: block;
            border: none;
            font-size: 20px;
        }
    }

    .menu {
        border-bottom: none;
        flex: 1;
        justify-content: flex-end;

        @media (max-width: 768px) {
            display: none;
        }

        :deep(.ant-menu-item) {
            font-size: 16px;

            a {
                color: $text-color;

                &:hover {
                    color: $primary-color;
                }
            }
        }
    }

    .language-switcher {
        margin-left: 16px;

        .ant-dropdown-link {
            color: rgba(0, 0, 0, 0.85);
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 4px;
        }
    }

    .active {
        color: #1890ff;
        font-weight: 500;
    }

    @media (max-width: 768px) {
        .language-switcher {
            display: none;
        }
    }
}

// 抽屉菜单样式
.drawer-menu {
    border-right: none;

    :deep(.ant-menu-item) {
        height: 50px;
        line-height: 50px;
        margin: 4px 0;

        a {
            color: $text-color;
            font-size: 16px;

            &:hover {
                color: $primary-color;
            }
        }
    }
}
</style>
